import ActionTypes from '@constants/action_types.js'

export function changeCurrentColorScheme(colorScheme) {
  return {
    type: ActionTypes.CURRENT_COLOR_SCHEME_CHANGE,
    payload: colorScheme,
  }
}

export function changeEditableColorScheme(colorScheme) {
  return {
    type: ActionTypes.EDITABLE_COLOR_SCHEME_CHANGE,
    payload: colorScheme,
  }
}
